var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 3V0h-1v3h-3v1h3v3h1V4h3V3zm-4 14.5c0 .828-.597 1.5-1.333 1.5H2.333C1.597 19 1 18.328 1 17.5v-.012C1 16.006 3.686 14 7 14s6 2.006 6 3.488zM7 13c-3.866 0-7 2.675-7 4.651V18c0 1.105.696 2 1.555 2h10.889c.859 0 1.556-.895 1.556-2v-.349C14 15.675 10.866 13 7 13m0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
});
const SvgAddApproverIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddApproverIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8dGl0bGU+NzlDQjYyRDAtOTBGQi00RTAzLUI3MDYtOTUwMzBCRDQ5RDBEPC90aXRsZT4NCiAgICA8cGF0aCBkPSJNMTcgM1YwaC0xdjNoLTN2MWgzdjNoMVY0aDNWM2gtM3ptLTQgMTQuNWMwIC44MjgtLjU5NyAxLjUtMS4zMzMgMS41SDIuMzMzQzEuNTk3IDE5IDEgMTguMzI4IDEgMTcuNXYtLjAxMkMxIDE2LjAwNiAzLjY4NiAxNCA3IDE0czYgMi4wMDYgNiAzLjQ4OHYuMDEyek03IDEzYy0zLjg2NiAwLTcgMi42NzUtNyA0LjY1MVYxOGMwIDEuMTA1LjY5NiAyIDEuNTU1IDJoMTAuODg5Yy44NTkgMCAxLjU1Ni0uODk1IDEuNTU2LTJ2LS4zNDlDMTQgMTUuNjc1IDEwLjg2NiAxMyA3IDEzem0wLTlhMyAzIDAgMSAxIDAgNiAzIDMgMCAwIDEgMC02em0wIDdhNCA0IDAgMSAwIDAtOCA0IDQgMCAwIDAgMCA4eiINCiAgICAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4NCjwvc3ZnPg==";